export default __webpack_public_path__ + "static/media/NovaGPT_logo_white.65c8e629.svg";